export default {
  path: '/previous-imports',
  component: () => import(/* webpackChunkName: "previous-imports" */ './PreviousImports'),
  meta: {
    requiresAuth: true
  }
}
